import { createSelector } from 'reselect';
import { PortfoliosInceptionDTO, TabSlug } from '../types';
import { WidgetsState } from './reducer';

const accountPerformanceReportingSelector = state => state.accountPerformanceReporting;

export const periodSelector = createSelector(
  accountPerformanceReportingSelector,
  ({ period }) => period,
);

export const positionsDateSelector = createSelector(
  accountPerformanceReportingSelector,
  ({ positionsDate }) => positionsDate,
);

const focusedAccountSelector = createSelector(
  accountPerformanceReportingSelector,
  ({ focusedAccount }) => focusedAccount,
);

export const accountsSelector = createSelector(
  [accountPerformanceReportingSelector],
  ({ accounts }) => accounts,
);

export const focusedAccountIdSelector = createSelector(
  focusedAccountSelector,
  ({ accountId }) => accountId,
);

export const areOptionsLoadedSelector = createSelector(
  accountPerformanceReportingSelector,
  ({ areOptionsLoaded }) => areOptionsLoaded,
);

export const optionsSelector = createSelector(
  accountPerformanceReportingSelector,
  ({ options }) => options,
);

export const selectIsLoadingApexApplicants = createSelector(
  focusedAccountSelector,
  ({ isLoadingApexApplicants }) => isLoadingApexApplicants,
);

export const selectApexApplicants = createSelector(
  focusedAccountSelector,
  ({ apexApplicants }) => apexApplicants,
);

export const selectFetchAccountApplicantsErrors = createSelector(
  focusedAccountSelector,
  ({ fetchAccountApplicantsErrors }) => fetchAccountApplicantsErrors,
);

export const selectUpdateApexAccountErrors = createSelector(
  focusedAccountSelector,
  ({ updateApexAccountErrors }) => updateApexAccountErrors,
);

export const selectInceptionDates = createSelector(
  optionsSelector,
  ({ portfoliosInception }: { portfoliosInception: PortfoliosInceptionDTO }) => {
    return Object.values(portfoliosInception).reduce((acc, entities) => {
      entities.forEach(({ id, inceptionDate }) => {
        acc[id] = inceptionDate;
      });

      return acc;
    }, {} as Record<string, string | null>);
  },
);

export const selectTransactionFilters = createSelector(
  accountPerformanceReportingSelector,
  periodSelector,
  ({ transactionFilters, period }) => ({ ...transactionFilters, period }),
);

const selectPerformanceGroup: (state: any) => WidgetsState['performanceGroupSelection'] = state =>
  state.accountPerformanceReporting.performanceGroupSelection;

const selectIncomeGroup: (state: any) => WidgetsState['incomeGroupSelection'] = state =>
  state.accountPerformanceReporting.incomeGroupSelection;

export const selectGroupSelectionData = (tabSlug: TabSlug) =>
  createSelector(selectPerformanceGroup, selectIncomeGroup, (performanceGroup, incomeGroup) => {
    if (tabSlug === TabSlug.Performance) {
      return performanceGroup;
    }

    return incomeGroup;
  });
